type Value = { categories: string[], categoryMeta: Array<{ _id?: string, judgeOnly: boolean, description: string }> };

/** Categories without a name are dropped on save, so an "Add category" left empty doesn't become a blank category. */
export const withoutBlankCategories = <T extends Value>(data: T): T => {
    const keep = data.categories.map(c => !!c.trim());
    return {
        ...data,
        categories: data.categories.filter((_, i) => keep[i]).map(c => c.trim()),
        categoryMeta: data.categoryMeta.filter((_, i) => keep[i])
    };
};
